import loadWorklet from '../common/volume-meter/worklet-loader';
import { getAudioContext } from '../utils/audio-context';

// 压缩工具：https://skalman.github.io/UglifyJS-online/
const workletNode = 'registerProcessor("dumper",class extends AudioWorkletProcessor{constructor(e){super(),this.sourceSampleRate=e.processorOptions.sourceSampleRate||48e3,this.targetSampleRate=e.processorOptions.targetSampleRate||48e3,this.port.onmessage=e=>{this.port2=e.data.port}}process(e){return(this.port2||this.port).postMessage(this.resampleAll(e,this.sourceSampleRate,this.targetSampleRate)),!0}resampleAll(r,s,a){if(s===a)return r;var o=[];for(let t=0;t<r.length;t++){o[t]=[];for(let e=0;e<r[t].length;e++)o[t][e]=this.resample(r[t][e],s,a)}return o}resample(t,e,r){if(e===r)return t;var s=Math.round(t.length*(this.targetSampleRate/this.sourceSampleRate)),a=new Float32Array(s),o=(t.length-1)/(s-1);a[0]=t[0];for(let e=1;e<s-1;e++){var l=e*o,p=Math.floor(l),h=Math.ceil(l);a[e]=t[p]+(t[h]-t[p])*(l-p)}return a[s-1]=t[t.length-1],a}});';
let dumpAudioWorkletReady: Promise<void>;
export async function startGetPCM(sources: AudioNode[], targetSampleRate = 48000, channelCount = 1, port?: MessagePort) {
  const context = getAudioContext('dump');
  if (!dumpAudioWorkletReady) dumpAudioWorkletReady = loadWorklet(context, URL.createObjectURL(new Blob([workletNode], { type: 'application/javascript' })));
  await dumpAudioWorkletReady;
  const sourceSampleRate = context.sampleRate;
  const _audioWorkletNode = new AudioWorkletNode(context, 'dumper', { numberOfInputs: sources.length, numberOfOutputs: 0, processorOptions: { sourceSampleRate, targetSampleRate } });
  _audioWorkletNode.channelCountMode = 'explicit';
  _audioWorkletNode.channelCount = channelCount;
  if (port) _audioWorkletNode.port.postMessage({ port }, [port]);
  sources.forEach((source, i) => source.connect(_audioWorkletNode, 0, i));
  return new ReadableStream<Float32Array[][]>({
    start(controller) {
      _audioWorkletNode.port.onmessage = (event: MessageEvent<Float32Array[][]>) => {
        controller.enqueue(event.data);
      };
    },
    cancel() {
      sources.forEach(source => source.disconnect(_audioWorkletNode));
      _audioWorkletNode.port.close();
    }
  });
}

// // DO NOT REMOVE: 压缩前的 workletNode
// const _workletNode = `registerProcessor("dumper", class extends AudioWorkletProcessor {
//   constructor(e) {
//     super();
//     this.sourceSampleRate = e.processorOptions.sourceSampleRate || 48000;
//     this.targetSampleRate = e.processorOptions.targetSampleRate || 48000;
//     this.port.onmessage = (event) => {
//       this.port2 = event.data.port;
//     };
//   }
//   process(input) {
//     (this.port2 || this.port).postMessage(this.resampleAll(input, this.sourceSampleRate, this.targetSampleRate));
//     return true;
//   }
//   resampleAll(data, sourceSampleRate, targetSampleRate) {
//     if (sourceSampleRate === targetSampleRate) return data;
//     const output = [];
//     for (let i = 0; i < data.length; i++) {
//       output[i] = [];
//       for (let j = 0; j < data[i].length; j++) {
//         output[i][j] = this.resample(data[i][j], sourceSampleRate, targetSampleRate);
//       }
//     }
//     return output;
//   }
//   resample(data, sourceSampleRate, targetSampleRate) {
//     if (sourceSampleRate === targetSampleRate) return data;
//     const fitCount = Math.round(data.length * (this.targetSampleRate / this.sourceSampleRate));
//     const newData = new Float32Array(fitCount);
//     const springFactor = (data.length - 1) / (fitCount - 1);
//     newData[0] = data[0];
//       for (let i = 1; i < fitCount - 1; i++) {
//       const tmp = i * springFactor;
//       const before = Math.floor(tmp);
//       const after = Math.ceil(tmp);
//       const atPoint = tmp - before;
//       newData[i] = data[before] + (data[after] - data[before]) * atPoint;
//     }
//     newData[fitCount - 1] = data[data.length - 1];
//     return newData;
//   }
// });`;
